import React, { useState } from 'react';
import QRCode from 'react-qr-code';
import md5 from 'md5';
import { Alert, Form, Col, Row, Button, Card, Spinner } from 'react-bootstrap';
import api from '../../services/api';
import AppFooter from '../../components/AppFooter';

const INITIAL_FORM = {
  codRequisicao: '',
  codPaciente: '',
  cpfUpdate: '',
  origem: '',
};

// TODO: validar no backend e aqui!
const NUMERIC_FIELDS = ['codRequisicao', 'codPaciente', 'cpfUpdate'];

export default function ValidaRequisicao() {
  const [form, setForm] = useState(INITIAL_FORM);
  const [validated, setValidated] = useState(false);
  const [status, setStatus] = useState({ kind: 'idle' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isDisabled = isSubmitting || status.kind === 'success';

  const handleClickICM = event => {
    event.preventDefault();
    window.location.href = 'https://icm.com.br';
  };

  const handleChange = field => event => {
    const raw = event.target.value;
    const value = NUMERIC_FIELDS.includes(field)
      ? raw.replace(/\D/g, '')
      : raw;
    setForm(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async event => {
    event.preventDefault();
    const formEl = event.currentTarget;

    setValidated(true);

    if (!formEl.checkValidity()) {
      event.stopPropagation();
      return;
    }

    setIsSubmitting(true);
    setStatus({ kind: 'idle' });

    try {
      const result = await api.put(
        `/paciente/requisicao/${form.codRequisicao}`,
        {
          status: 'Validado',
          origem: form.origem,
          cpfUpdate: form.cpfUpdate,
          codPaciente: form.codPaciente,
        }
      );

      setStatus({
        kind: 'success',
        message: result?.data?.message ?? 'Requisição validada com sucesso!',
        requisicao: result?.data?.requisicao ?? null,
      });
    } catch (err) {
      const serverMessage = err?.response?.data?.message;
      const serverRequisicao = err?.response?.data?.requisicao ?? null;

      if (serverMessage) {
        setStatus({
          kind: 'error',
          message: serverMessage,
          requisicao: serverRequisicao,
        });
        return;
      }

      if (err?.request && !err?.response) {
        setStatus({
          kind: 'error',
          message: 'Erro no servidor! Verifique sua conexão e tente novamente.',
          requisicao: null,
        });
        return;
      }

      setStatus({
        kind: 'error',
        message: 'Erro ao validar a requisição!',
        requisicao: null,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const authHash = status.requisicao
    ? md5(JSON.stringify(status.requisicao.DESCRICAO))
    : null;

  return (
    <Row className="justify-content-md-center mb-1 mt-5">
      <Col md="auto">
        <Card border="success" className="text-center">
          <Card.Header>
            <Card.Title className="text-success">
              <strong>VALIDAÇÃO DE REQUISIÇÃO DE EXAMES</strong>
            </Card.Title>
            {status.kind === 'success' && (
              <>
                <Alert variant="success">{status.message}</Alert>
                {authHash && <Card.Text>Autenticação: {authHash}</Card.Text>}
              </>
            )}
            {status.kind === 'error' && (
              <>
                <Alert variant="danger">{status.message}</Alert>
                {authHash && <Card.Text>Autenticação: {authHash}</Card.Text>}
              </>
            )}
          </Card.Header>

          <Card.Body>
            <Card.Text className="text-success font-weight-bold">
              Informe os dados abaixo para VALIDAR a Requisição de Exames!
            </Card.Text>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <Form.Row>
                <Form.Group as={Col} sm>
                  <Form.Label htmlFor="inputRequisicao">
                    <strong>CÓDIGO DA REQUISIÇÃO</strong>
                  </Form.Label>
                  <Form.Control
                    className="text-center"
                    required
                    type="text"
                    id="inputRequisicao"
                    name="codRequisicao"
                    inputMode="numeric"
                    pattern="\d+"
                    autoComplete="off"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck={false}
                    value={form.codRequisicao}
                    onChange={handleChange('codRequisicao')}
                    disabled={isDisabled}
                    aria-describedby="requisicaoHelp"
                  />
                  <Form.Text id="requisicaoHelp" muted>
                    <div className="text-primary">
                      Digite o Código da Requisição.
                    </div>
                  </Form.Text>
                </Form.Group>
                <Form.Group as={Col} sm>
                  <Form.Label htmlFor="inputPaciente">
                    <strong>CÓDIGO DO PACIENTE</strong>
                  </Form.Label>
                  <Form.Control
                    className="text-center"
                    required
                    type="text"
                    id="inputPaciente"
                    name="codPaciente"
                    inputMode="numeric"
                    pattern="\d+"
                    autoComplete="off"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck={false}
                    value={form.codPaciente}
                    onChange={handleChange('codPaciente')}
                    disabled={isDisabled}
                    aria-describedby="pacienteHelp"
                  />
                  <Form.Text id="pacienteHelp" muted>
                    <div className="text-primary">
                      Digite o Código do Paciente.
                    </div>
                  </Form.Text>
                </Form.Group>
              </Form.Row>
              <Form.Row>
                <Form.Group as={Col} sm>
                  <Form.Label htmlFor="inputCPF">
                    <strong>CPF DO PROFISSIONAL</strong>
                  </Form.Label>
                  <Form.Control
                    className="text-center"
                    required
                    type="text"
                    id="inputCPF"
                    name="cpfUpdate"
                    maxLength={11}
                    inputMode="numeric"
                    pattern="\d{11}"
                    autoComplete="off"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck={false}
                    value={form.cpfUpdate}
                    onChange={handleChange('cpfUpdate')}
                    disabled={isDisabled}
                    aria-describedby="cpfHelp"
                  />
                  <Form.Text id="cpfHelp" muted>
                    <div className="text-primary">
                      Informe o CPF do Profissional que está realizando a
                      validação da Requisição.
                    </div>
                  </Form.Text>
                </Form.Group>
              </Form.Row>
              <Form.Row>
                <Form.Group as={Col} sm>
                  <Form.Label htmlFor="inputProfissional">
                    <strong>NOME DO PROFISSIONAL</strong>
                  </Form.Label>
                  <Form.Control
                    className="text-center"
                    required
                    type="text"
                    id="inputProfissional"
                    name="origem"
                    value={form.origem}
                    onChange={handleChange('origem')}
                    disabled={isDisabled}
                    aria-describedby="profissionalHelp"
                  />
                  <Form.Text id="profissionalHelp" muted>
                    <div className="text-primary">
                      Informe o Nome do Profissional que está validando a
                      Requisição.
                    </div>
                  </Form.Text>
                </Form.Group>
              </Form.Row>
              <Form.Row>
                <Form.Group as={Col} sm className="text-center">
                  <Button type="submit" size="lg" disabled={isDisabled}>
                    {isSubmitting ? (
                      <Spinner animation="border" size="sm" role="status" />
                    ) : (
                      'Validar'
                    )}
                  </Button>{' '}
                  <Button
                    type="button"
                    variant="secondary"
                    size="lg"
                    onClick={handleClickICM}
                    disabled={isSubmitting}
                  >
                    Ir para o ICM
                  </Button>
                </Form.Group>
              </Form.Row>
            </Form>
          </Card.Body>
          <Card.Footer className="text-muted">
            <QRCode size={50} value="https://www.moraes-tech.com/" />
            <AppFooter />
          </Card.Footer>
        </Card>
      </Col>
    </Row>
  );
}
